/**
 * Cancels a queued or running Google Health fetch (admin callable cancelHealthFetch).
 * Chunks not yet started skip themselves; a chunk already being fetched finishes.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

/**
 * @param {string} jobId
 * @param {Function} addAlert
 * @return {Promise<void>}
 */
export default async function cancelFetch(jobId, addAlert) {
  // eslint-disable-next-line no-alert
  if (!window.confirm('Cancel this fetch? Chunks not yet started are skipped; data already fetched is kept.')) return;
  try {
    await httpsCallable(functions, 'cancelHealthFetch')({ jobId });
    addAlert('success', 'Fetch cancelled');
  } catch (err) {
    addAlert('error', `Could not cancel: ${err.message}`);
  }
}
